module.exports = __webpack_public_path__ + "static/media/social-good.52865b8d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/categories/social-good.svg
 ** module id = 450
 ** module chunks = 0
 **/